import type { ProtocolStatus } from '../types'

export function signingRuntimeLabel(status?: ProtocolStatus) {
  return status?.signingRuntime?.displayName || 'ES256 签名服务'
}

export function signingRuntimeAssurance(status?: ProtocolStatus) {
  if (!status?.signingRuntime) return '签名运行状态不可用；签发前会由服务端再次执行密钥库与签名校验。'
  const runtime = status.signingRuntime
  return `${runtime.displayName} / kid ${runtime.keyId} / 密钥库 ${runtime.keyStoreStatus}`
}
